import { render } from "./InternalForm.vue?vue&type=template&id=06ecbb57"
import script from "./InternalForm.vue?vue&type=script&lang=js"
export * from "./InternalForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__